import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NbButtonModule, NbCardModule, NbCheckboxModule } from '@nebular/theme';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PopupBlockedDialogComponent } from './popup-blocked-dialog.component';

const routes: Routes = [

]

const context: any = {}

@NgModule({
  declarations: [PopupBlockedDialogComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    NbButtonModule,
    NbCheckboxModule,
    NbCardModule,
    FlexLayoutModule,


  ],
})
export class PopupBlockedDialogModule { }
